export enum PurchaseOrderStatus {
    PENDING = 'PENDING',
    CONFIRMED_APPROVED = 'CONFIRMED_APPROVED',
    CANCELLED = 'CANCELLED',
    DELIVERED = 'DELIVERED',
    RECEIVE_INVENTORY = 'RECEIVE_INVENTORY',
    PARTIALLY_DELIVERED = 'PARTIALLY_DELIVERED',
    CLOSED = 'CLOSED'
}
